// extracted by mini-css-extract-plugin
export default {"monthSelect":"_1YXj","monthLabel":"_1hNq","floatRight":"_26Xy"};